import { ifProp, theme } from 'styled-tools';

import BackgroundImage from '@/components/BackgroundImage';
// import PropTypes from "prop-types";
import React from 'react';
import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';

const Section = styled.section<{
  bgColor?: string;
  minHeight: string | number;
}>`
  width: 100%;
  min-height: ${(props) => props.minHeight};
  overflow-x: hidden;
  position: relative;
  z-index: 98;
  padding-top: 0;

  ${breakpoint('md')`
    max-width: 100vw;
  `}

  color: ${ifProp({ bgColor: 'blue' }, theme('colors.white'), theme('colors.blue'))};
  background-color: ${ifProp({ bgColor: 'blue' }, theme('colors.blue'), theme('colors.white'))};
`;

interface SectionProps {
  children: React.ReactNode;
  bgImage?: unknown;
  minHeight?: string | number;
  bgColor?: string;
}

const BackgroundSection: React.FC<SectionProps> = ({ children, bgImage, minHeight = '100vh', ...props }) => {
  if (bgImage) {
    return (
      <Section minHeight={minHeight} {...props}>
        <BackgroundImage Tag="div" img={bgImage} style={{ position: 'unset' }} fadeIn={false} loading="eager">
          {children}
        </BackgroundImage>
      </Section>
    );
  }

  return (
    <Section minHeight={minHeight} {...props}>
      {children}
    </Section>
  );
};

export default BackgroundSection;
